import { render, staticRenderFns } from "./CustomerDeliveryDialog.vue?vue&type=template&id=610160d0&scoped=true"
import script from "./CustomerDeliveryDialog.vue?vue&type=script&lang=js"
export * from "./CustomerDeliveryDialog.vue?vue&type=script&lang=js"
import style0 from "./CustomerDeliveryDialog.vue?vue&type=style&index=0&id=610160d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610160d0",
  null
  
)

export default component.exports